<template>
    <div class="mx-auto" style="width: 100vh;">
        <form-wizard 
            @on-complete="onComplete"
            @on-change="onChange"
            :title="title"
            :subtitle="subtitle"
            :hide-buttons="hideButton"
        >
            <tab-content 
                title="Business Details"
                :before-change="check"
            >
                <BusinessDetails ref="businessDetails"/>
            </tab-content>
            <tab-content title="Map">
                <Map ref="map"/>
            </tab-content>
            <tab-content title="Confirm">
                <Agreement/>
            </tab-content>
        </form-wizard>
    </div>
</template>

<style scoped>

</style>

<script>
import BusinessDetails from '../components/business/add/BusinessDetails'
import Map from '../components/business/add/Map'
import Agreement from '../components/business/add/Agreement'
import { v4 as uuidv4 } from 'uuid';

export default {
    name: 'AddNewBusiness',
    components: {
        BusinessDetails,
        Map,
        Agreement
    },
    data() {
        return {
            title: "Add New Business",
            subtitle: "Let's add a new business in few easy steps",
            hideButton: false
        }
    },
    computed: {
        addNewBusiness_response: {
            get() {
                return this.$store.state.addNewBusiness_response.id
            }
        }
    },
    watch: {
        addNewBusiness_response(newValue) {
            // if not empty, push to new route
            if (newValue != '') {
                this.$router.push({
                    name: 'Place',
                    params: {
                        id: newValue
                    }
                })
            }
            // reset the id back to ''
            this.$store.dispatch('resetAddNewBusiness')
            this.hideButton = false
        }
    },
    methods: {
        onComplete: function() {
            console.log('finish clicked')
            // send to api to add new business
            console.log('liveCenter', this.$refs.map.liveCenter)
            var tmpCategories = []
            for (let tag of this.$refs.businessDetails.selectedTags) {
                tmpCategories.push(tag.value)
            }

            var payload = {
                source: 'gozhere',
                sourceId: uuidv4(),
                name: this.$refs.businessDetails.name,
                latitude: this.$refs.map.liveCenter[1],
                longitude: this.$refs.map.liveCenter[0],
                categories: tmpCategories,
                locationAddress1: this.$refs.businessDetails.street,
                locationCity: this.$refs.businessDetails.city,
                locationCountry: 'PH',
                phone: this.$refs.businessDetails.phone,
                website: this.$refs.businessDetails.web
            }
            this.hideButton = true
            this.$store.dispatch('saveAddNewBusiness', payload)
        },
        onChange: function(prevIndex, nextIndex) {
            console.log('onChange')
            console.log('prevIndex', prevIndex)
            console.log('nextIndex', nextIndex)
            if (nextIndex == 1) {
                console.log('resizing')
                this.$root.$emit('resizeMapAddNewBusiness');
                
            }
        },
        check: function() {
            return this.$refs.businessDetails.check2()
        }
    },
    mounted() {
    }
}
</script>